// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2999":"css/admin-app.7003","8764":"css/app.7003"}[chunkId] + ".css";
};